import { Page } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconPage12Line = createIcon(Page, 12, "Line");
export const IconPage16Line = createIcon(Page, 16, "Line");
export const IconPage20Line = createIcon(Page, 20, "Line");
export const IconPage24Line = createIcon(Page, 24, "Line");
export const IconPage32Line = createIcon(Page, 32, "Line");
export const IconPage48Line = createIcon(Page, 48, "Line");
export const IconPage64Line = createIcon(Page, 64, "Line");
